import { fg } from '@atlaskit/platform-feature-flags';
import { CONFIG_ITEM_KEYS } from '../../../config-items/config-item-keys';
import { suggestConfigItemForConfluenceTitleToolbar } from '../../../prebuilt/config-items-range/suggest/suggest';
import { EventHubPrompt } from '../types';
var getConfigFromProvider = function getConfigFromProvider(editorPluginAIProvider, configType, key) {
  var provider = editorPluginAIProvider[configType];
  if (key === CONFIG_ITEM_KEYS.FREE_GENERATE) {
    return provider.baseGenerate;
  } else {
    var _provider$getSuggesti;
    var configItem = (_provider$getSuggesti = provider.getSuggestions({
      inputValue: ''
    })) === null || _provider$getSuggesti === void 0 ? void 0 : _provider$getSuggesti.find(function (suggestion) {
      return suggestion.key === key;
    });
    return configItem;
  }
};
var getConfigTypeByAdjustSelection = function getConfigTypeByAdjustSelection(adjustSelection) {
  switch (adjustSelection) {
    case 'fullDocument':
      {
        return 'rangeConfig';
      }
    case 'keepCurrent':
      {
        return 'rangeConfig';
      }
    default:
      {
        return 'emptyConfig';
      }
  }
};
export var getConfigItem = function getConfigItem(prompt, editorPluginAIProvider, adjustSelection) {
  switch (prompt) {
    case EventHubPrompt.SuggestTitle:
      {
        return suggestConfigItemForConfluenceTitleToolbar;
      }
    case EventHubPrompt.CustomPrompt:
      {
        var freeGenerate = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.FREE_GENERATE);
        return freeGenerate;
      }
    case EventHubPrompt.IssueReformatter:
      {
        if (fg('platform.reformat-issue-with-template-in-jira_jc0pb')) {
          var issueReformatter = getConfigFromProvider(editorPluginAIProvider, 'rangeConfig', CONFIG_ITEM_KEYS.ADD_STRUCTURE);
          return issueReformatter;
        } else {
          return undefined;
        }
      }
    case EventHubPrompt.Summarize:
      {
        var summarize = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.SUMMARISE_WRITING);
        return summarize;
      }
    case EventHubPrompt.ImproveWriting:
      {
        var improveWriting = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.IMPROVE_WRITING);
        return improveWriting;
      }
    case EventHubPrompt.MakeShorter:
      {
        var makeShorter = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.MAKE_SHORTER);
        return makeShorter;
      }
    case EventHubPrompt.FixSpellingGrammar:
      {
        var fixSpellingGrammar = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.FIX_SPELLING_AND_GRAMMAR);
        return fixSpellingGrammar;
      }
    case EventHubPrompt.ChangeToneToProfessional:
      {
        var professionalTone = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.CHANGE_TONE_TO_PROFESSIONAL);
        return professionalTone;
      }
    case EventHubPrompt.ChangeToneToNeutral:
      {
        var neutralTone = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.CHANGE_TONE_TO_NEUTRAL);
        return neutralTone;
      }
    case EventHubPrompt.ChangeToneToEmpathetic:
      {
        var empatheticTone = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.CHANGE_TONE_TO_EMPATHETIC);
        return empatheticTone;
      }
    case EventHubPrompt.ChangeToneToCasual:
      {
        var _empatheticTone = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.CHANGE_TONE_TO_CASUAL);
        return _empatheticTone;
      }
    case EventHubPrompt.ChangeToneToEducational:
      {
        var _empatheticTone2 = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.CHANGE_TONE_TO_EDUCATIONAL);
        return _empatheticTone2;
      }
    default:
      {
        return undefined;
      }
  }
};